import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import {  ExtraSmallButton, PrimaryButton } from "../../../../Constant";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonFlateButton from "../Common/CommonFlatButton";
import { FLAT_EXTRA_SMALL_BUTTONS, FLAT_EXTRA_SMALL_BUTTONS_LIST } from "../../../../Data/Buttons/FlatStyle";

const FlatExtraSmallButtons = () => {
    const [buttonTooltip, setButttooltip] = useState(false);
    const buttonToggle = () => setButttooltip(!buttonTooltip);
    return (
      <Card>
        <CommonCardHeader title={ExtraSmallButton} span={FLAT_EXTRA_SMALL_BUTTONS} />
        <CardBody className="btn-showcase">
          <Btn size="xs" color="primary" className="btn-square" id="Tooltip-22">{PrimaryButton}</Btn>
          <ToolTip target="Tooltip-22" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-square btn-primary btn-xs</ToolTip>
          {FLAT_EXTRA_SMALL_BUTTONS_LIST.map((data, index) => (
            <CommonFlateButton key={index} item={data} size="xs" />
          ))}
        </CardBody>
      </Card>
    );
};

export default FlatExtraSmallButtons;
